<template>
  <v-dialog class='video-link-dialog' v-model='videoDialog' max-width='500px'>
    <template v-slot:activator='{on}'><v-btn v-if="roundType==='REGISTERED'" :disabled="roundInfo.status!=='REVIEW' && roundInfo.status!=='OPEN'" text color='primary' v-on='on'><v-icon small>fa-plus</v-icon>&nbsp;&nbsp;Add Video</v-btn></template>
    <v-card>
      <v-card-title class='headline'>Submit Video Evidence</v-card-title>
      <v-card-text>Submit video evidence for round {{id}}. This must be an uncut video starting from when you open the scrambles to when you submit the solve times. Upload this to any video hosting website such as YouTube/Google Drive/Vimeo/etc. After submitting, ensure the link is correct on your results page and make sure it is publically accessible.</v-card-text>
      <v-text-field v-model='videoLink' label='Video Link' placeholder='eg. https://www.youtube.com/watch?v=dQw4w9WgXcQ' />
      <v-card-actions>
        <v-spacer />
        <v-btn text color='primary' :disabled="this.videoLink === ''" @click='submitVideoLink'>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RoundsService from '@/services/TPC/RoundsService'

export default {
  name: 'video-link-dialog',
  data () {
    return {
      videoDialog: false,
      videoLink: ''
    }
  },
  props: {
    id: String,
    roundType: String,
    roundInfo: Object
  },
  methods: {
    async submitVideoLink () {
      let videoLink = this.videoLink
      if (!videoLink.startsWith('http://') && !videoLink.startsWith('https://')) videoLink = 'http://' + videoLink
      let resp = await RoundsService.addVideoLink({
        roundID: this.id,
        solverOrder: this.roundInfo.ord,
        videoLink
      })
      if (!resp.data.success) {
        alert(`Try again. If it continues to fail, show the following error message to the organizers [error: ${resp.data.error}: ${resp.data.message}]`)
      }
      this.videoDialog = false
    }
  }
}
</script>

<style scoped>
.v-card__text {
  text-align: left;
  font-weight: 500;
  font-size: 15px;
}
.v-input {
  width: 90%;
  margin-left: 5%;
}
</style>
